import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button, Typography } from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3)
  },
  spacer: {
    flexGrow: 1
  },
  selectButton: {
    marginLeft: theme.spacing(3)
  },
  datePiker: {
    marginRight: theme.spacing(3)
  }
}));

const Toolbar = props => {
  const {
    className,
    startDate,
    endDate,
    total,
    onStartDateChange,
    onEndDateChange,
    onMakeReport,
    ...rest
  } = props;

  const classes = useStyles();

  // const [selectedStartDate, setSelectedStartDate] = React.useState(new Date());
  // const [selectedEndDate, setSelectedEndDate] = React.useState(new Date());
  const [selectedStartDate, setSelectedStartDate] = React.useState(startDate);
  const [selectedEndDate, setSelectedEndDate] = React.useState(endDate);

  const handleStartDateChange = date => {
    onStartDateChange(date);
  };

  const handleEndDateChange = date => {
    onEndDateChange(date);
  };

  useEffect(() => {
    setSelectedStartDate(props.startDate);
    setSelectedEndDate(props.endDate);
  }, [props.startDate, props.endDate]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div {...rest} className={clsx(classes.root, className)}>
        <div className={classes.row}>
          <Typography variant="h2" component="h2" gutterBottom>
            Отчет по деньгам за питание за день
          </Typography>
        </div>

        <div className={classes.row}>
          {/* <SearchInput
          className={classes.searchInput}
          placeholder="Search user"
        /> */}

          <KeyboardDatePicker
            className={classes.datePiker}
            margin="normal"
            id="date-picker-dialog"
            label="Выберите начальную дату"
            format="dd.MM.yyyy"
            value={selectedStartDate}
            onChange={handleStartDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
          />

          <KeyboardDatePicker
            className={classes.datePiker}
            margin="normal"
            id="date-picker-end-dialog"
            label="Выберите конечную дату"
            format="dd.MM.yyyy"
            value={selectedEndDate}
            onChange={handleEndDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
          />

          {/* <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={"13.02.2020"}
          // onChange={handleChange}
        >
          <MenuItem value={"13.02.2020"}>13.02.2020</MenuItem>
          <MenuItem value={"14.02.2020"}>14.02.2020</MenuItem>
          <MenuItem value={"15.02.2020"}>15.02.2020</MenuItem>

        </Select> */}
          <Button
            variant="contained"
            color="primary"
            className={classes.selectButton}
            onClick={onMakeReport}>
            Создать отчет
          </Button>
        </div>
        <div className={classes.row}>
          <Typography variant="h3" component="h2" gutterBottom>
            В сумме: <b>{total.toLocaleString('ru')} ฿</b>
          </Typography>
        </div>
      </div>
    </MuiPickersUtilsProvider>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
